import * as React from "react";
import {observer} from "mobx-react";
import {withAppStores} from "../../../AppStores";
import {IconButton} from "../../widgets/button/IconButton";
import {TextInput} from "../../widgets/input/text/TextInput";
import {SVGIcon} from "../../widgets/button/SVGIcon";
import type {AppState} from "../../../data/state/AppState";
import {ReactUtils} from "../../utils/ReactUtils";
import type {Organization} from "../../../data/models/Organization";
import {StringUtils} from "../../../utils/data/string/StringUtils";
import {navigateToNewOrg, switchOrganization} from "../../5.0/navigation/OrganizationSwitchUtils";

interface ISwitchOrganizationProps {
	readonly open?: boolean;
	readonly toggleOrganizationSwitch?: () => void;
	readonly appState?: AppState;
}

interface ISwitchOrganizationState {
	query: string;
}

@withAppStores("appState", "transport")
@observer
export class OrganizationSwitch extends React.Component<ISwitchOrganizationProps, ISwitchOrganizationState> {
	constructor(props: ISwitchOrganizationProps) {
		super(props);

		this.state = {
			query: "",
		};
	}

	private onAfterNavigateToNewOrg = () => {
		this.props.toggleOrganizationSwitch();
	};

	private onClickOrganization = (org: Organization) => {
		switchOrganization(org, this.props.appState, this.onAfterNavigateToNewOrg);
	};

	private navigateToNewOrg = (newOrgId: string) => {
		navigateToNewOrg(newOrgId, this.props.appState);
		this.onAfterNavigateToNewOrg();
	};

	public override render() {
		const {appState, open, toggleOrganizationSwitch} = this.props;
		const organizations = appState.organizations;
		const query = this.state.query.toLowerCase() || "";

		return (
			<>
				<div className={ReactUtils.cls("OrganizationSwitch", {open: open})}>
					<IconButton
						icon="arrow"
						className="goBack"
						onClick={toggleOrganizationSwitch}
					/>
					{open && (
						<TextInput
							placeholder="Search Organization..."
							onInput={(value) => this.setState({query: value})}
							autoFocus={true}
						/>
					)}
					<div className="organizationsList">
						<ul>
							{organizations
								.filter((org) => StringUtils.containsIgnoreCase(org.name, query))
								.sort((orgA, orgB) => StringUtils.sortIgnoreCase(orgA.name, orgB.name))
								.map((org, key) => (
									<li
										key={key}
										className={ReactUtils.cls("OrganizationItem", {selected: org.id === appState.organizationIdByAuthData})}
										onClick={() => this.onClickOrganization(org)}
									>
										<SVGIcon icon="checkmark" />
										<h2>{org.name}</h2>
									</li>
								))}
						</ul>
					</div>
				</div>
			</>
		);
	}
}
